import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common/common.service';

import { DynamicItem } from 'src/app/models/dynamicItem';
import { PopupNewIdentifierComponent } from '../popups/popup-new-identifier/popup-new-identifier.component';

@Component({
  selector: 'app-identifier-list',
  templateUrl: './identifier-list.component.html',
  styleUrls: ['./identifier-list.component.scss']
})
export class IdentifierListComponent implements OnInit {
  
  breadcrumb: { "label": string; "link": any[]; }[] = [];
  identifiersInfo: any = [];
  showPopupFlag: boolean = false;
  popupData: any;


  constructor(
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.getIdentifiers();
    this.setBreadcrumb();
  }

  deleteIdentifier(identifierId) {
    this.commonService.deleteIdentifier(identifierId).subscribe((res) => {
      this.identifiersInfo = this.identifiersInfo.filter((item) => {
        return item.id != identifierId;
      });
    });
  }

  openNewIdentifierPopup() {
    let popuptext: any = {
      heading: "NEW IDENTIFIER",
      body: "",
      isSaveMandatory: true,
      successCallback: this.addNewIdentifier.bind(this),
      cancelCallback: this.closePopup.bind(this)
    }
    this.popupData = new DynamicItem(PopupNewIdentifierComponent, popuptext);
    this.showPopupFlag = true;
  }


  getIdentifiers() {
    this.commonService.getUserIdentifiers().subscribe((res) => {
      this.identifiersInfo = res
    });
  }

  addNewIdentifier(identifier) {
    this.showPopupFlag = false;

    this.commonService.postIdentifiersInfo(identifier).subscribe((res) => {
      this.getIdentifiers();
    });
  }

  closePopup() {
    this.showPopupFlag = false;
  }

  setBreadcrumb() {
    this.breadcrumb = [
      { "label": "List of identifiers", "link": ["/profile"] },
    ];
  }
}
